<template>
    <v-menu
        :key="menuKey"
        :model-value="open"
        location="bottom start"
        offset="6"
        :close-on-content-click="false"
        :scrim="false"
        @update:model-value="onOpenChange"
    >
        <template #activator="{ props: menuProps }">
            <span v-if="variant === 'ware-button'" class="d-inline-flex">
                <v-btn
                    v-bind="menuProps"
                    size="default"
                    color="yellow"
                    variant="outlined"
                    data-cy="entries-fuel-calculator-menu-button"
                    @click.stop
                >
                    <template v-if="appliedFuelCostLabel">
                        {{ $t("formFields.fuelCostResult") }}:&nbsp;{{
                            appliedFuelCostLabel
                        }}
                    </template>
                    <template v-else>
                        {{ $t("entries.fuelCalculator") }}
                    </template>
                </v-btn>
                <v-tooltip activator="parent" location="bottom">
                    {{
                        appliedFuelCostLabel
                            ? $t("entries.fuelCalculatorAppliedTooltip")
                            : $t("entries.fuelCalculatorTooltip")
                    }}
                </v-tooltip>
            </span>

            <span v-else class="d-inline-flex">
                <v-btn
                    v-bind="menuProps"
                    density="compact"
                    color="primary"
                    variant="flat"
                    data-cy="publish-fuel-calculator-menu-button"
                    @click.stop
                >
                    <template v-if="appliedFuelCostLabel">
                        {{ $t("formFields.fuelCostResult") }}:&nbsp;{{
                            appliedFuelCostLabel
                        }}
                    </template>
                    <template v-else>
                        {{ $t("entries.fuelCalculator") }}
                    </template>
                </v-btn>
                <v-tooltip activator="parent" location="bottom">
                    {{
                        appliedFuelCostLabel
                            ? $t("entries.fuelCalculatorAppliedTooltip")
                            : $t("entries.fuelCalculatorTooltip")
                    }}
                </v-tooltip>
            </span>
        </template>

        <FuelCalculatorPanel
            ref="panel"
            :price-per-liter="pricePerLiter"
            :distance-km="distanceKm"
            :consumption-l-per100-km="consumptionLPer100Km"
            @update:price-per-liter="$emit('update:pricePerLiter', $event)"
            @update:distance-km="$emit('update:distanceKm', $event)"
            @update:consumption-l-per100-km="
                $emit('update:consumptionLPer100Km', $event)
            "
            @apply="$emit('apply', $event)"
        />
    </v-menu>
</template>

<script>
import FuelCalculatorPanel from "./FuelCalculatorPanel.vue";

export default {
    name: "FuelCalculatorMenu",
    components: {
        FuelCalculatorPanel,
    },
    props: {
        entry: {
            type: Object,
            default: null,
        },
        open: {
            type: Boolean,
            default: false,
        },
        pricePerLiter: {
            type: [String, Number],
            default: "",
        },
        distanceKm: {
            type: [String, Number],
            default: "",
        },
        consumptionLPer100Km: {
            type: [String, Number],
            default: "",
        },
        appliedFuelCostLabel: {
            type: String,
            default: "",
        },
        variant: {
            type: String,
            default: "toolbar-button",
            validator: (value) =>
                ["toolbar-button", "ware-button"].includes(value),
        },
    },
    emits: [
        "update:open",
        "update:pricePerLiter",
        "update:distanceKm",
        "update:consumptionLPer100Km",
        "apply",
    ],
    computed: {
        menuKey() {
            const entryUid = this.entry?.uid ?? "publish";
            return `fuel-calculator-${entryUid}-${this.variant}`;
        },
    },
    methods: {
        onOpenChange(open) {
            if (!open) {
                requestAnimationFrame(() => {
                    const panelEl = this.$refs.panel?.$el;
                    if (panelEl?.contains(document.activeElement)) {
                        this.$emit("update:open", true);
                        return;
                    }
                    this.$refs.panel?.tryApply();
                    this.$emit("update:open", false);
                });
                return;
            }
            this.$emit("update:open", open);
        },
    },
};
</script>
